// Datos ficticios de ejemplo — plantilla "Prisma" (eventos formales:
// capacitaciones, reuniones, conferencias). El "protagonista" es el evento.

export const datosEjemplo = {
  tipoEvento: "formal",
  plantillaId: "formal-prisma",

  secciones: [
    { id: "portada", visible: true, orden: 0 },
    { id: "cuentaRegresiva", visible: true, orden: 1, etiqueta: "Cuenta regresiva", titulo: "Comienza en", textoFinalizado: "¡Estamos en vivo!" },
    { id: "eventos", visible: true, orden: 2, etiqueta: "Sede", titulo: "Lugar y horarios" },
    { id: "calendario", visible: true, orden: 3, etiqueta: "Agenda", titulo: "Añadilo a tu calendario" },
    { id: "galeria", visible: true, orden: 4, etiqueta: "Ediciones anteriores", titulo: "Así se vivió" },
    { id: "itinerario", visible: true, orden: 5, etiqueta: "Programa", titulo: "Agenda del día" },
    { id: "menciones", visible: true, orden: 6, etiqueta: "Disertantes", titulo: "Quienes presentan" },
    { id: "video", visible: true, orden: 7, etiqueta: "Video", titulo: "Mirá el resumen anterior" },
    { id: "musica", visible: false, orden: 8, etiqueta: "Música", titulo: "Playlist del evento" },
    { id: "rsvp", visible: true, orden: 9, etiqueta: "Registro", titulo: "Reservá tu lugar" },
    { id: "enlaces", visible: true, orden: 10, etiqueta: "Recursos", titulo: "Material y enlaces" },
    { id: "accesos", visible: true, orden: 11, etiqueta: "Participación", titulo: "Sumá tu aporte" },
    { id: "cierre", visible: true, orden: 12 },
  ],

  protagonista: {
    nombre: "Summit de Innovación",
    fraseIntroductoria: "3ª edición · Capacitación empresarial",
    mensajePortada:
      "Un día completo de charlas, talleres y networking con referentes de la industria tecnológica paraguaya.",
    mensajeCierre:
      "Gracias por ser parte de esta edición. Nos reencontramos el próximo año.",
    textoBotonEntrada: "Ver programa",
  },

  evento: {
    fechaISO: "2027-03-11T08:30:00-03:00",
    fechaLegible: "Jueves 11 de marzo de 2027",
    fechaCorta: "11 · 03 · 2027",
    ciudad: "Asunción, Paraguay",
  },

  fotos: {
    portada:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&auto=format&fit=crop",
    galeria: [
      {
        src: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Auditorio durante la keynote",
      },
      {
        src: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Escenario con presentación",
      },
      {
        src: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Panel de disertantes",
      },
      {
        src: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Taller práctico en grupo",
      },
    ],
  },

  eventos: [
    {
      id: "jornada",
      etiqueta: "Jornada completa",
      lugar: "Centro de Convenciones Paseo La Galería",
      direccion: "Av. Santa Teresa esq. Aviadores del Chaco, Asunción",
      horario: "08:30 a 18:00 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Paseo+La+Galer%C3%ADa+Asunci%C3%B3n",
      textoBoton: "Cómo llegar",
    },
  ],

  calendario: {
    titulo: "Summit de Innovación 2027",
    descripcion: "Jornada de 08:30 a 18:00 h en el Centro de Convenciones Paseo La Galería.",
    texto: "Jueves 11 de marzo de 2027 · Asunción. Acreditación desde las 08:00 h.",
    textoBotonGoogle: "Google Calendar",
    textoBotonIcs: "Descargar evento (.ics)",
    inicioISO: "2027-03-11T08:30:00-03:00",
    finISO: "2027-03-11T18:00:00-03:00",
    ubicacion: "Centro de Convenciones Paseo La Galería, Asunción, Paraguay",
  },

  itinerario: [
    { hora: "08:30", titulo: "Acreditación y café", descripcion: "Recepción de participantes.", icono: "reloj" },
    { hora: "09:00", titulo: "Apertura", descripcion: "Palabras de bienvenida del comité.", icono: "brillo" },
    { hora: "09:30", titulo: "Keynote principal", descripcion: "Transformación digital en la región.", icono: "musica" },
    { hora: "11:00", titulo: "Talleres simultáneos", descripcion: "Tres tracks a elección.", icono: "cena" },
    { hora: "13:00", titulo: "Almuerzo de networking", descripcion: "Incluido con la acreditación.", icono: "copas" },
    { hora: "15:00", titulo: "Panel de casos", descripcion: "Empresas paraguayas cuentan su experiencia.", icono: "fiesta" },
    { hora: "17:30", titulo: "Cierre y brindis", descripcion: "Conclusiones y próximos pasos.", icono: "corazon" },
  ],

  menciones: [
    {
      nombre: "Ing. Marcela Ayala",
      rol: "Keynote · Transformación digital",
      foto: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Lic. Rodrigo Vera",
      rol: "Panel · Casos de éxito",
      foto: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Dra. Sofía Benítez",
      rol: "Taller · Datos aplicados",
      foto: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "MBA. Jorge Martínez",
      rol: "Taller · Liderazgo",
      foto: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
  ],

  video: {
    urlYoutube: "https://www.youtube.com/watch?v=aqz-KE-bpKQ",
  },

  musica: {
    tipo: "spotify",
    url: "https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M",
    nota: "Dale play cuando quieras. La música nunca arranca sola.",
  },

  rsvp: {
    mensaje:
      "Los cupos son limitados y la acreditación es nominal. Reservá tu lugar con anticipación.",
    textoBoton: "Reservar mi lugar",
    fechaLimite: "Inscripciones hasta el 28 de febrero de 2027",
  },

  enlaces: [
    { texto: "Programa completo (PDF)", url: "https://pro360.com.py" },
    { texto: "Sitio del organizador", url: "https://pro360.com.py" },
  ],

  accesos: {
    libroFirmas: {
      titulo: "Consultas previas",
      texto: "Enviá tus preguntas para los paneles.",
    },
    album: {
      titulo: "Material y fotos",
      texto: "Accedé a las presentaciones después del evento.",
    },
  },

  legal: {
    urlPrivacidad: "https://pro360.com.py/privacidad",
    urlCondiciones: "https://pro360.com.py/condiciones",
    textoPrivacidad: "Privacidad",
    textoCondiciones: "Condiciones",
    marca: "Organizado con Pro360 Invitaciones Digitales Plus",
  },
};
